/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { styled } from 'styled-components';
import { IComandaEtapaReunioes, IEtapa } from '../../../commons/types/crm';
import { authAtom } from '../../../states/usuarios/AuthState';
import NoticiaCard from './NoticiaCard';
import BannerCard from './BannerCard';
import { history } from '../../../helpers/history';
import { IArea, IConteudo, IMenu, ISecao } from '../../../commons/types/base';
import { useMenusActions } from '../../../states/menus/menu.actions';
import { IEvento } from '../../../commons/types/eventos';
import { IEventosQuery } from '../../Eventos/Externos';
import { useEventosActions } from '../../../states/eventos/eventos.actions';
import dayjs from 'dayjs';
import { ptBR, esES } from '@mui/material/locale';
import { useTranslation } from '../../../commons/useTranslasion';
import { useNoticiaActions } from '../../../states/noticias/noticia.actions';
import { INoticia } from '../../../commons/types/noticia';
import { Box, Card, CardContent, CardMedia } from '@mui/material';
import { OutlinedButton } from '../../../commons/styleds/buttons';

const Noticias: React.FC = () => {
  const { language, translate } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }

  const bannerActions = useMenusActions();
  const noticiaActions = useNoticiaActions();
  const actions = useEventosActions();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [banners, setBanners] = useState<IConteudo[]>([]);
  const [recentes, setRecentes] = useState<IConteudo[]>([]);
  const [eventos, setEventos] = useState<IEvento[]>([]);
  const [eventosQuery, setEventosQuery] = useState<IEventosQuery>({
    tipo: '',
    dataInicio: null,
    dataFim: null,
    apenasAtivos: true,
  });
  const [areaEventos, setAreaEventos] = useState<IArea[]>([]);
  const [secaoWorkshops, setSecaoWorkshops] = useState<ISecao | null>(null);
  const [noticias, setNoticias] = useState<INoticia[]>([]);
  const menusActions = useMenusActions();
  const [translationsLoaded, setTranslationsLoaded] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex === banners.length - 1 ? 0 : prevIndex + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [banners]);

  useEffect(() => {
    const translatedValue = translate('statoInforma');
    if (translatedValue !== 'statoInforma') {
      setTranslationsLoaded(true);
    }
  }, [translate]);

  useEffect(() => {
    if (!translationsLoaded) {
      return;
    }

    bannerActions.get().then((res: any) => {
      const conteudo = res.resultado.conteudos.filter((c: IConteudo) => c.idSecaos?.find((s: ISecao) => s.nome === translate('statoInforma')));

      const banners = conteudo
        .filter((c: IConteudo) => c.anexo !== null)
        .sort((a: IConteudo, b: IConteudo) =>
          new Date(b.dtPublicacao! ?? '').getTime() - new Date(a.dtPublicacao! ?? '').getTime()
        )
        .slice(0, 5);
      setBanners(banners);

      const conteudosRecentes = conteudo
        .filter((c: IConteudo) => c.dtPublicacao)
        .sort((a: IConteudo, b: IConteudo) =>
          new Date(b.dtPublicacao! ?? '').getTime() - new Date(a.dtPublicacao! ?? '').getTime()
        )
        .slice(0, 3);
      setRecentes(conteudosRecentes);

      menusActions
        .get()
        .then((d) => {
          const menus: IMenu = d.resultado;

          const area = menus.areas.find((f) => f.nome == "Eventos");
          const secao = menus.secoes.find((f) => f.nome == "Workshops");

          setAreaEventos(area ? [area] : []);
          setSecaoWorkshops(secao!);
        })
    });

    if (lang === 'pt-br') {
      noticiaActions.filter({
        pagina: 1,
        tamanhoPagina: 5
      }).then((res: any) => {
        const noticias = res.itens;
        setNoticias(noticias);
      });
    }
  }, [translationsLoaded, translate, lang]);

  const onClickBanner = (id: any) => {
    const conteudo = banners.find((f) => f.id === id);
    const area = conteudo?.idAreas?.find((a) => a.nome === 'Notícias');
    const secao = conteudo?.idSecaos?.find((a) => a.nome === translate('statoInforma'));
    history.push(`/menus/${area?.id}/secoes/${secao?.id}/conteudos/${id}`);
  };

  const onClickEventos = () => {
    history.push(`/menus/${areaEventos[0].id!}/secoes/${secaoWorkshops?.id}`);
  };

  const loadData = async () => {
    const resp = await actions.list(false, makeQueryParams());

    const eventosFuturos = resp.filter((evento: IEvento) =>
      new Date(evento.dtPrevista!) > new Date()
    );

    setEventos(eventosFuturos);
  }

  useEffect(() => {
    loadData();
  }, []);

  const makeQueryParams = () => {
    const queryParams = new URLSearchParams();
    if (eventosQuery.dataInicio) {
      queryParams.set('dataInicio', eventosQuery.dataInicio.toISOString());
    }
    if (eventosQuery.dataFim) {
      queryParams.set('dataFim', eventosQuery.dataFim.toISOString());
    }
    return `?${queryParams.toString()}`;
  }

  const cardBanner = () => (
    <div style={{
      height: '100%', width: '100%',
      backgroundImage: `url(${banners[currentImageIndex]?.anexo})`,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      borderRadius: "16px",
    }}>

      <Grid container spacing={1}>
        <Grid size={{ xs: 12, md: 12, sm: 12 }} sx={{ display: 'flex', justifyContent: 'center', paddingTop: '20px' }} onClick={() => onClickBanner(banners[currentImageIndex]?.id)}>
          <Grid size={{ xs: 12, md: 7, sm: 7 }} sx={{ padding: '20px', background: 'white', borderRadius: '16px' }}>
            <Typography variant="subtitle2" sx={{ color: 'black' }}>
              {banners[currentImageIndex]?.titulo}
            </Typography>
            <Typography variant="caption" sx={{ color: 'black', wordBreak: "break-all" }}>
              {banners[currentImageIndex]?.resumo?.substring(0, 100)}
            </Typography>
          </Grid>
        </Grid>

        <Grid onClick={() => setCurrentImageIndex((prevIndex) => (prevIndex === banners.length - 1 ? 0 : prevIndex + 1))} sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'white',
          width: '40px',
          height: '40px',
          borderRadius: '50px',
          cursor: 'pointer',
          position: 'absolute',
          right: '10px',
          top: '45%',
          boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)'
        }}>
          {'>'}
        </Grid>

        <Grid onClick={() => setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? banners.length - 1 : prevIndex - 1))} sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'white',
          width: '40px',
          height: '40px',
          borderRadius: '50px',
          cursor: 'pointer',
          position: 'absolute',
          left: '10px',
          top: '45%',
          boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)'
        }}>
          {'<'}
        </Grid>

        <Grid sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'white',
          width: 'auto',
          height: '30px',
          borderRadius: '50px',
          cursor: 'pointer',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: '5%',
          boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)'
        }}>
          {
            banners.map((b, index) => (
              (currentImageIndex === index ?
                <span style={{
                  padding: '5px',
                  borderRadius: '50px',
                  background: 'black',
                  margin: '5px',
                  cursor: 'pointer',
                }}
                  onClick={() => setCurrentImageIndex(index)}
                >
                </span>
                :
                <span style={{
                  padding: '5px',
                  borderRadius: '50px',
                  background: 'black',
                  margin: '5px',
                  cursor: 'pointer',
                  opacity: 0.5
                }}
                  onClick={() => setCurrentImageIndex(index)}
                >
                </span>
              )
            ))
          }
        </Grid>
      </Grid>
    </div >

  );

  return (
    <SuasNoticiasDiv>
      {banners.length > 0 ?
        <>
          <Typography variant="h3" sx={{ marginBottom: '20px' }}>
            {translate('statoInforma')}
          </Typography>
          <BannerCard headerTitle="">{cardBanner()}</BannerCard>
        </> : <></>}

      {lang === 'pt-br' ?
        <>
          <Grid sx={{ marginTop: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <Typography variant="h3">{translate('noticias')}</Typography>
              </div>
              <div>
                <OutlinedButton to="/noticias">{translate('todasNoticias')}</OutlinedButton>
              </div>
            </div>
          </Grid>
          <Box
            sx={{
              display: 'flex',
              flexWrap: { xs: 'wrap', sm: 'nowrap' },
              gap: '20px',
              justifyContent: { xs: 'center', sm: 'space-between' },
              pb: '10px',
              width: '100%',
              margin: '0 auto',
              marginTop: '30px',
              marginBottom: '0'
            }}
          >
            {noticias.map((noticia) => (
              <NoticiaCard key={noticia.id} noticia={noticia} />
            ))}
          </Box>
        </> : <></>}
    </SuasNoticiasDiv>
  );
};

const SuasNoticiasDiv = styled.div`
  padding: 48px 0px;
`;

export default Noticias;
